// extracted by mini-css-extract-plugin
export default {"container":"TablePaymentStatusIndicatorCell_container__gXTIw"};